module.exports = __webpack_public_path__ + "static/media/fortlev-solar-logo-256.b3f975d0.png";